import axios from 'axios'
// import store from './store'
// import router from './router'

const instance = axios.create({
    baseURL: 'https://demo.schooney.tech:18074'
})

// Add a request interceptor
instance.interceptors.request.use(
    config => {
        const token = localStorage.getItem('jwt')
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
            config.headers['Accept-Language'] = localStorage.getItem('lang')
        } else {
            // router.push({ name: 'ErrorPage' }, () => {})
        }

        config.timeout = 600000 // time out 10 min

        return config
    },
    error => {
        Promise.reject(error)
    }
)

export default instance
